export default __webpack_public_path__ + "static/media/tiger_12.08d4523b.mp3";